import React, { useEffect, useState } from "react"
import "./adjectifCv.scss"
import { Grid } from "@mui/material"
import AdjectifCloud from "./adjectifCloud"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import CvSkillDto from "../../../../../api/models/cvskill"
import cvskillService from "../../../../../api/services/cvskillService"
import logoTipeo from "../../../../../resources/images/LOGO_TIPEO_V1.png"

interface AdjectifCvProps {
	theme: ThemeCvDto | null
}
function AdjectifCv({ theme }: AdjectifCvProps) {
	const [cvSkill, setCvSkill] = useState<CvSkillDto | null>(null)
	const [error, setError] = useState<string | null>(null)

	useEffect(() => {
		const fetchData = async () => {
			const storedUserId = localStorage.getItem("selectedUserId")

			try {
				if (storedUserId) {
					const fetchedCvSkill =
						await cvskillService.getCvSkillsByUserId(
							Number(storedUserId),
						)
					setCvSkill(fetchedCvSkill)
				}
			} catch (error) {
				setError("CV Skill non trouvé pour cet utilisateur")
			}
		}

		fetchData()
	}, [])

	const getAdjs = (): string[] => {
		const adjsList = [
			...(cvSkill?.polePersonnaliteTraits?.map(
				element => element.personnaliteTrait,
			) || []),
			...(cvSkill?.polePersonnalitesTypes?.flatMap(
				element => element.associatedTraits,
			) || []),
		]

		return adjsList
	}

	const styleBloc: React.CSSProperties = {
		borderRight: `2px solid ${theme?.colorBorder}`,
		borderTop: `2px solid ${theme?.colorBorder}`,
		padding: "30px",
		display: "inline-block",
		backgroundColor: `${theme?.adjColorBackground}`,
		minHeight: "820px",
		backgroundImage: `url("${theme?.adjImgBackground}")`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "left",
		fontFamily: `"${theme?.fontFamily}", "sans-serif"`,
		position: "relative",
	}

	const styleLogo: React.CSSProperties = {
		position: "absolute",
		bottom: "20px",
		left: "20px",
		width: "90px",
		zIndex: 10,
	}

	return (
		<Grid size={6} style={styleBloc} sx={{ alignItems: "center" }}>
			<AdjectifCloud
				words={getAdjs()}
				color={theme?.adjColorBackground}
				theme={theme}
			/>
			<img src={logoTipeo} alt="Logo" style={styleLogo} />
		</Grid>
	)
}

export default AdjectifCv
